import { Box, Tab, Tabs } from '@mui/material';
import { SyntheticEvent, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import { ActiveUsersTab } from './active-tab';
import { DeletedUsersTab } from './deleted-tab';

type UsersTab = 'active' | 'deleted';

const parseTab = (raw: string | null): UsersTab => (raw === 'deleted' ? 'deleted' : 'active');

export const Users = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = parseTab(searchParams.get('tab'));

  // Оба таба используют одни и те же ключи (filter/page/sortBy...), поэтому при переключении
  // query-строка очищается: параметры в URL всегда принадлежат текущему табу.
  const handleTabChange = useCallback(
    (_: SyntheticEvent, value: UsersTab) => {
      setSearchParams(value === 'deleted' ? { tab: 'deleted' } : {}, { replace: true });
    },
    [setSearchParams],
  );

  return (
    <Box display="flex" flexDirection="column">
      <Box px={3} pt={2}>
        <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.05)', borderRadius: '8px', width: 'fit-content' }}>
          <Tabs value={tab} onChange={handleTabChange}>
            <Tab value="active" label="Active" />
            <Tab value="deleted" label="Deleted" />
          </Tabs>
        </Box>
      </Box>

      {tab === 'active' ? (
        <ActiveUsersTab />
      ) : (
        <Box px={3} py={2}>
          <DeletedUsersTab />
        </Box>
      )}
    </Box>
  );
};
